import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import { LAYOUT } from "../../configuration/theme";

const HERO_IMAGE = "static/images/aero-ateam.png";
const HERO_INTRINSIC_WIDTH = 210;
const HERO_INTRINSIC_HEIGHT = 201;

const CreatorProgramHero = () => {
    const { dependency_root } = ConfigurationHelper.getGlobalConfiguration();
    const applyUrl = ConfigurationHelper.getCreatorApplyUrl();

    return (
        <Container
            sx={{
                px: LAYOUT.pagePad,
                pt: "22px",
                display: "flex",
                gap: "28px",
                alignItems: "center",
                flexWrap: "wrap",
            }}
        >
            <Box
                component="img"
                src={`${dependency_root}${HERO_IMAGE}`}
                alt="Aéropostale A-Team"
                width={HERO_INTRINSIC_WIDTH}
                height={HERO_INTRINSIC_HEIGHT}
                decoding="async"
                onError={(event) => {
                    event.currentTarget.style.display = "none";
                }}
                sx={{
                    flex: "none",
                    width: "132px",
                    height: "auto",
                    aspectRatio: `${HERO_INTRINSIC_WIDTH} / ${HERO_INTRINSIC_HEIGHT}`,
                    borderRadius: "10px",
                    display: "block",
                }}
            />
            <Box sx={{ flex: "1 1 380px", minWidth: 0 }}>
                <Typography
                    component="h1"
                    sx={{
                        fontSize: { xs: "30px", md: "38px" },
                        fontWeight: 800,
                        margin: "0 0 8px",
                        letterSpacing: "-0.9px",
                        lineHeight: 1.05,
                    }}
                >
                    Meet the Aero A-Team
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#4A4340", margin: 0, textWrap: "pretty" }}>
                    Real fits from Aéropostale&rsquo;s creator community &mdash; shop every look
                </Typography>
                {applyUrl && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                            flexWrap: "wrap",
                            marginTop: "12px",
                        }}
                    >
                        <Box component="span" sx={{ fontSize: "14px", color: "#4A4340", textWrap: "pretty" }}>
                            Think you have what it takes to join the A-Team?
                        </Box>
                        <Box
                            component="a"
                            href={applyUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                height: "32px",
                                padding: "0 16px",
                                borderRadius: "999px",
                                backgroundColor: (theme) => theme.tvp.cta,
                                color: (theme) => theme.tvp.ctaInk,
                                fontSize: "12.5px",
                                fontWeight: 700,
                                textDecoration: "none",
                                transition: "background-color 120ms ease",
                                "&:hover": {
                                    backgroundColor: (theme) => theme.tvp.ctaHover,
                                    textDecoration: "none",
                                },
                            }}
                        >
                            Apply now
                        </Box>
                    </Box>
                )}
            </Box>
        </Container>
    );
};

export default CreatorProgramHero;
